import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { FadeUp } from '../motion/FadeUp';
import { LogoMark } from '../brand/Logo';
const HERO_ARTWORK = 'https://cdn.magicpatterns.com/uploads/jZRZ1nZzSdGtZGnLyLrxsz/Gemini_Generated_Image_1wftg31wftg31wft.png';
export function Hero() {
  return <section id="top" className="relative flex min-h-[100svh] w-full items-center justify-center overflow-hidden bg-white px-6 pt-24 pb-20" data-id="element-121" data-mp="hv7k3lbsv75j">
      {/* Purposefully subdued yantra artwork, positioned beneath the brand name. */}
      <div aria-hidden="true" className="pointer-events-none absolute left-1/2 top-[68%] h-[126vw] max-h-[780px] w-[126vw] max-w-[780px] -translate-x-1/2 -translate-y-1/2 opacity-10" style={{
      backgroundImage: `url(${HERO_ARTWORK})`,
      backgroundSize: 'contain',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      maskImage: 'radial-gradient(circle, #000 54%, transparent 77%)',
      WebkitMaskImage: 'radial-gradient(circle, #000 54%, transparent 77%)'
    }} data-id="element-122" data-mp="qtsweyqohpxv" />

      <div className="relative mx-auto flex max-w-3xl flex-col items-center text-center" data-id="element-123" data-mp="4nohw3j85gp1">
        <FadeUp data-id="element-124" data-mp="3vu94nb28y2g9">
          <LogoMark className="mx-auto h-16 w-16 md:h-20 md:w-20" data-id="element-125" data-mp="3vvsjqyc627gg" />
        </FadeUp>

        <FadeUp delay={0.08} data-id="element-126" data-mp="3ru797jn3u59f">
          <p className="mt-8 text-sm font-medium uppercase tracking-[0.26em] text-vermillion sm:text-[15px]" data-id="element-127" data-mp="3rv8o5z78rbwf">
            Haerumbah Pvt Ltd
          </p>
        </FadeUp>

        <FadeUp delay={0.14} data-id="element-128" data-mp="ng8ueaem996o">
          <h1 className="mt-5 text-4xl font-semibold leading-[1.08] tracking-tightest text-ink sm:text-5xl md:text-6xl" data-id="element-129" data-mp="nfzejfnaciep">
            Building products that make everyday life happier &amp; healthier.
          </h1>
        </FadeUp>

        <FadeUp delay={0.22} data-id="element-130" data-mp="1b4s3ut9ejs0c">
          <p className="mx-auto mt-7 max-w-xl text-lg leading-relaxed text-ink/60" data-id="element-131" data-mp="1b51yiu5e6ncd">
            We create thoughtful technology that enriches everyday experiences,
            strengthens communities, and helps people live happier, healthier lives.
          </p>
        </FadeUp>

        <FadeUp delay={0.3} data-id="element-132" data-mp="35ljs0mqo7x73">
          <p className="mt-6 text-[15px] text-ink/50" data-id="element-133" data-mp="35jp5x53nxz1f">
            <span className="font-medium text-ink/80" data-id="element-134" data-mp="2qw46pm9wsjys">Our Vision:</span>{' '}
            <span className="italic" data-id="element-135" data-mp="2qu1f4xt3yiry">Creating a Happy • Healthy • Humanity.</span>
          </p>
        </FadeUp>

        <FadeUp delay={0.38} data-id="element-136" data-mp="2vsum07dw3bj5">
          <div className="mt-10 flex justify-center" data-id="element-137" data-mp="2hv69bmtz7ap6">
            <a href="#product" className="group inline-flex items-center gap-2 rounded-full bg-[#2f5f1e] px-7 py-3.5 text-[15px] font-medium text-white transition-colors hover:bg-[#244a17]" data-id="element-138" data-mp="2hxiq3wnzzf0n">
              Explore Kraya
              <ArrowRightIcon className="h-4 w-4 transition-transform group-hover:translate-x-0.5" data-id="element-139" data-mp="2cxe985j6gi9w" />
            </a>
          </div>
        </FadeUp>
      </div>
    </section>;
}